export function INIT(state) {
	state.init = true;
}

export function RESET(state) {
	state.users = [];
	state.loggedInAs = null;
	state.external = null;
	state.datasource = null;
	state.subscriptions = null;
}

export function SET_USERS(state, users) {
	state.users = users;
}

export function LOGIN(state, userId) {
	state.loggedInAs = userId;
}

export function LOGOUT(state) {
	state.loggedInAs = null;
}

export function SET_USER(state, user) {
	state.user = user;
}

export function UPDATE_USER(state, data) {
	Object.assign(state.user, data);
}

export function SET_EXTERNAL(state, external) {
	state.external = external;
}

export function UPDATE_DATASOURCE(state, datasource) {
	state.datasource = datasource;
}

export function SET_SUBSCRIPTIONS(state, subscriptions) {
	state.subscriptions = subscriptions;
}
